/* eslint-disable prettier/prettier */
import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Button, Col, Form, Input, message, Popconfirm, Row } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';

import Utils from '../../../Assets/Scripts/Utils';
import {
  applyRegisterCustomFields,
  createRegisterShowField,
  RegisterLayoutBody,
  useRegisterFieldLayout,
} from '../../../Components/ResourceFieldLayout/RegisterFieldLayout';
import { api } from '../../../Services/axiosService';

function InvoiceIssuerRegister() {
  const { id: editId } = useParams();
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [screenModified, setScreenModified] = useState(false);
  const [fieldsPermissions, setFieldsPermissions] = useState();
  const { fieldLayout, roleId } = useRegisterFieldLayout('InvoiceIssuer');
  const showField = createRegisterShowField(fieldsPermissions, fieldLayout, roleId);

  const fetchInvoiceIssuerEdit = async (id) => {
    setLoading(true);

    const res = await api
      .get(`/InvoiceIssuer?id=${id}`)
      .then((res) => res.data)
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Algo deu errado ao buscar os dados!');
      });

    form.setFieldsValue(applyRegisterCustomFields(res));
    setLoading(false);
  };

  const onFinish = async (values) => {
    setLoading(true);
    // Create a new object with values
    const dataToSubmit = { ...values };

    const httpMethod = editId ? 'put' : 'post';
    await api[httpMethod]('/InvoiceIssuer', dataToSubmit)
      .then(() => {
        message.success(`Dados ${editId ? 'atualizados' : 'salvos'}!`);
        form.resetFields();

        if (editId) {
          fetchInvoiceIssuerEdit(editId);
        } else {
          navigate('/EmissorNotaFiscal/Listar');
        }

        setLoading(false);
        setScreenModified(false);
      })
      .catch((error) => {
        Utils.logError(error);
        message.error('Oops. Erro ao enviar os dados do Emissor de Nota Fiscal!');
        setLoading(false);
      });
  };

  useLayoutEffect(() => {
    const permissions = {};
    JSON.parse(localStorage.getItem('conecta__permissions'))?.resources.forEach(
      ({ name, fields }) => {
        if (name === 'InvoiceIssuer') {
          fields.forEach(({ name, access, isRequired }) => {
            permissions[name] = { access, isRequired };
          });
        }
      }
    );
    setFieldsPermissions(permissions);
  }, []);

  useEffect(() => {
    if (editId) {
      fetchInvoiceIssuerEdit(editId);
    }
  }, []);

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      autoComplete="off"
      onChange={() => setScreenModified(true)}
      style={{ maxWidth: '100%', margin: '0 auto' }}
    >
      <div className="form-toolbar">
        {screenModified && (
          <Popconfirm
            title="Deseja mesmo voltar?"
            onConfirm={() => navigate(-1)}
            okText="Sim"
            cancelText="Não"
          >
            <Button>Voltar</Button>
          </Popconfirm>
        )}
        {!screenModified && <Button onClick={() => navigate(-1)}>Voltar</Button>}
        <Button loading={loading} block type="primary" htmlType="submit">
          Salvar
        </Button>
      </div>
      {/* Campos invisiveis */}
      <Form.Item className="input-hidden" label="Id" name="id">
        <Input />
      </Form.Item>

      <Row gutter={[24]}>
        <RegisterLayoutBody
          fieldLayout={fieldLayout}
          fieldsPermissions={fieldsPermissions}
          roleId={roleId}
          widgetMap={{
    Name: () => showField('Name') && (
<Col span={8}>
            <Form.Item
              label="Nome"
              name="name"
              rules={[
                {
                  required: fieldsPermissions?.Name?.isRequired || true,
                  message: 'Campo obrigatório!',
                },
              ]}
            >
              <Input disabled={fieldsPermissions?.Name?.access !== 2} />
            </Form.Item>
          </Col>
    ),
    Cnpj: () => showField('Cnpj') && (
<Col span={8}>
            <Form.Item
              label="CNPJ"
              name="cnpj"
              rules={[
                {
                  required: fieldsPermissions?.Cnpj?.isRequired || true,
                  message: 'Campo obrigatório!',
                },
                {
                  pattern: /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/,
                  message: 'Formato inválido. Use XX.XXX.XXX/XXXX-XX',
                },
                {
                  min: 18,
                  max: 18,
                  message: 'CNPJ deve ter 18 caracteres',
                },
              ]}
            >
              <Input
                disabled={fieldsPermissions?.Cnpj?.access !== 2}
                placeholder="XX.XXX.XXX/XXXX-XX"
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, '');
                  if (value.length <= 14) {
                    const masked = value
                      .replace(/^(\d{2})(\d)/, '$1.$2')
                      .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
                      .replace(/\.(\d{3})(\d)/, '.$1/$2')
                      .replace(/(\d{4})(\d)/, '$1-$2');
                    form.setFieldsValue({ cnpj: masked });
                  }
                }}
                maxLength={18}
              />
            </Form.Item>
          </Col>
    )
  }}
          form={form}
          loading={loading}
          padraoFields={
            <>
{showField('Name') && (
          <Col span={8}>
            <Form.Item
              label="Nome"
              name="name"
              rules={[
                {
                  required: fieldsPermissions?.Name?.isRequired || true,
                  message: 'Campo obrigatório!',
                },
              ]}
            >
              <Input disabled={fieldsPermissions?.Name?.access !== 2} />
            </Form.Item>
          </Col>
        )}

        {showField('Cnpj') && (
          <Col span={8}>
            <Form.Item
              label="CNPJ"
              name="cnpj"
              rules={[
                {
                  required: fieldsPermissions?.Cnpj?.isRequired || true,
                  message: 'Campo obrigatório!',
                },
                {
                  pattern: /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/,
                  message: 'Formato inválido. Use XX.XXX.XXX/XXXX-XX',
                },
                {
                  min: 18,
                  max: 18,
                  message: 'CNPJ deve ter 18 caracteres',
                },
              ]}
            >
              <Input
                disabled={fieldsPermissions?.Cnpj?.access !== 2}
                placeholder="XX.XXX.XXX/XXXX-XX"
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, '');
                  if (value.length <= 14) {
                    const masked = value
                      .replace(/^(\d{2})(\d)/, '$1.$2')
                      .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
                      .replace(/\.(\d{3})(\d)/, '.$1/$2')
                      .replace(/(\d{4})(\d)/, '$1-$2');
                    form.setFieldsValue({ cnpj: masked });
                  }
                }}
                maxLength={18}
              />
            </Form.Item>
          </Col>
        )}
            </>
          }
        />
      </Row>
    </Form>
  );
}

export default InvoiceIssuerRegister;
